import {
  Box,
  Heading,
  VStack,
  FormControl,
  FormLabel,
  Input,
  Button,
  IconButton,
  HStack,
  useToast,
  Flex,
} from "@chakra-ui/react";
import { AddIcon, DeleteIcon } from "@chakra-ui/icons";
import { useState } from "react";
import { criarCotacaoAutomatica } from "../services/api";

export default function CadastrarCotacao() {
  const toast = useToast();

  const [itens, setItens] = useState([
    { nome: "", marca: "", quantidade: "", codigo_global: "" },
  ]);


  const handleChange = (index, field, value) => {
    const updated = [...itens];
    updated[index][field] = value;
    setItens(updated);
  };

  const addItem = () => {
    setItens([...itens, { nome: "", marca: "", quantidade: "", codigo_global: "" }]);
  };

  const removeItem = (index) => {
    const updated = [...itens];
    updated.splice(index, 1);
    setItens(updated);
  };

  const enviar = async () => {
    try {
      const data = await criarCotacaoAutomatica(itens);
      toast({
        title: "Cotação enviada!",
        description: `Token: ${data.token}`,
        status: "success",
        duration: 5000,
        isClosable: true,
      });
      setItens([{ nome: "", marca: "", quantidade: "",codigo_global: "" }]);
    } catch (err) {
      console.error(err);
      toast({
        title: "Erro ao enviar cotação",
        description: "Verifique os dados e tente novamente.",
        status: "error",
        duration: 5000,
        isClosable: true,
      });
    }
  };


  return (
    <Flex minH="100vh" bg="gray.50" align="center" justify="center" px={8} py={10}>
      <Box
        bg="white"
        p={8}
        borderRadius="xl"
        shadow="lg"
        w="full"
        maxW="600px"
      >
        <Heading size="lg" mb={6} textAlign="center">
          Nova Cotação
        </Heading>

        <VStack spacing={6} align="stretch">
          {itens.map((item, index) => (
            <Box
              key={index}
              border="1px solid #E2E8F0"
              borderRadius="md"
              p={4}
            >
              <FormControl mb={3}>
                <FormLabel>Nome do Produto</FormLabel>
                <Input
                  placeholder="Ex: Filtro de óleo"
                  value={item.nome}
                  onChange={(e) => handleChange(index, "nome", e.target.value)}
                />
              </FormControl>
              <FormControl mb={3}>
                <FormLabel>Código Global</FormLabel>
                <Input
                  placeholder="Ex: 2RD311319"
                  value={item.codigo_global}
                  onChange={(e) => handleChange(index, "codigo_global", e.target.value)}
                />
              </FormControl>

              <FormControl mb={3}>
                <FormLabel>Marca Desejada</FormLabel>
                <Input
                  placeholder="Ex: Bosch"
                  value={item.marca}
                  onChange={(e) => handleChange(index, "marca", e.target.value)}
                />
              </FormControl>

              <FormControl>
                <FormLabel>Quantidade</FormLabel>
                <Input
                  type="number"
                  placeholder="Ex: 5"
                  value={item.quantidade}
                  onChange={(e) => handleChange(index, "quantidade", e.target.value)}
                />
              </FormControl>

              <HStack justifyContent="flex-end" mt={3}>
                {itens.length > 1 && (
                  <IconButton
                    icon={<DeleteIcon />}
                    aria-label="Remover"
                    size="sm"
                    onClick={() => removeItem(index)}
                  />
                )}
              </HStack>
            </Box>
          ))}

          <Button leftIcon={<AddIcon />} onClick={addItem} colorScheme="blue" variant="outline">
            Adicionar Item
          </Button>

          <Button colorScheme="green" onClick={enviar}>
            Enviar Cotação
          </Button>
        </VStack>
      </Box>
    </Flex>
  );
}
